import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import api from '@services/api'
import { useDispatch } from 'react-redux'
import { useAppConfig } from '@state/uses/app'
import { getAppConfig, setAppConfig } from '@state/actions/app'
import EmailDistributor from '@components/settings/EmailDistributor'
import EmailEditor from '@components/settings/EmailEditor'
import GeneralSettings from '@components/settings/GeneralSettings'
import UsersLog from '@components/settings/UsersLog'
import ConfirmModal from '@components/Modals/ConfirmModal'
import MessageModal from '@components/Modals/MessageModal'
import colors from '@constants/colors'
import { MainPageWrapper } from '@appearance/styled'
import i18n from '@localization/i18n'

const tabs = [
    {
        label: i18n.t('settings_headers.email_distributor'),
        name: 'email distributor',
    },
    {
        label: i18n.t('settings_headers.email_editor'),
        name: 'email editor',
    },
    {
        label: i18n.t('settings_headers.general'),
        name: 'general',
    },
    {
        label: i18n.t('settings_headers.users_log'),
        name: 'users log',
    },
]

export default () => {
    const dispatch = useDispatch()
    const appConfig = useAppConfig()
    const [currentTab, setCurrentTab] = useState('email distributor')
    const [newAppConfig, setNewAppConfigs] = useState(appConfig)
    const [showConfirmModal, setShowConfirmModal] = useState(false)
    const [showDoneModal, setShowDoneModal] = useState(false)

    useEffect(() => {
        if (!appConfig) {
            dispatch(getAppConfig(setNewAppConfigs))
        }
    }, [])

    const setNewAppConfigProp = (propObj) => {
        setNewAppConfigs(Object.assign({}, newAppConfig, propObj))
    }

    const saveAppConfig = () => {
        setShowConfirmModal(false)
        api.saveAppConfig(newAppConfig).subscribe(
            (res) => {
                setShowDoneModal(true)
                // console.log('saveAppConfig res', res)
                dispatch(setAppConfig(res.data))
            },
            (err) => console.log('saveAppConfig error', err)
        )
    }

    const openSaveConfigsModal = () => {
        setShowConfirmModal(true)
    }

    return (
        <MainPageWrapper backgroundColor={colors.APP_WHITE}>
            <Bar>
                <nav>
                    <NavUl>
                        {tabs.map((tab, i) => (
                            <Tab
                                onClick={() => setCurrentTab(tab.name)}
                                active={currentTab === tab.name}
                                key={'settings-tab-' + i}
                            >
                                {tab.label}
                            </Tab>
                        ))}
                    </NavUl>
                </nav>
            </Bar>
            <EmailDistributor
                show={currentTab === 'email distributor'}
                groups={newAppConfig && newAppConfig.groups}
            />
            <EmailEditor
                show={currentTab === 'email editor'}
                newAppConfig={newAppConfig}
                setNewAppConfigProp={setNewAppConfigProp}
                openSaveConfigsModal={openSaveConfigsModal}
            />
            <GeneralSettings
                show={currentTab === 'general'}
                newAppConfig={newAppConfig}
                setNewAppConfigProp={setNewAppConfigProp}
                openSaveConfigsModal={openSaveConfigsModal}
            />
            <UsersLog show={currentTab === 'users log'} />

            <ConfirmModal
                isOpen={showConfirmModal}
                onCancel={() => setShowConfirmModal(false)}
                onConfirm={saveAppConfig}
                title={'שמירת שינויים'}
                mainText={'האם את/ה בטוח/ה שברצונך לשמור את השינויים?'}
            />
            <MessageModal
                isOpen={showDoneModal}
                title={'השינויים נשמרו בהצלחה'}
                mainText={''}
                onClose={() => setShowDoneModal(false)}
            />
        </MainPageWrapper>
    )
}

const Bar = styled.div`
    width: 100%;
`

const NavUl = styled.ul`
    display: flex;
    font-size: 16px;
    align-items: center;
    list-style-type: none;
    border-bottom: 1px solid rgba(83, 71, 103, 0.4);
    margin-bottom: 0;

    @media (max-width: 768px) {
        flex-wrap: nowrap;
        display: list-item;
        align-items: center;
        width: auto;
        border-bottom: none;
    }
`

const Tab = styled.li`
    width: auto;
    cursor: pointer;
    margin: 0px 12px;
    padding: 4px 12px;
    text-align: center;
    list-style-type: none;
    justify-content: space-between;
    position: relative;
    bottom: -1px;
    background-color: ${(p) =>
        p.active ? colors.APP_GRAY_LIGHT : colors.COLOR_PRIMARY};

    border: 1px solid rgba(83, 71, 103, 0.4);
    border-bottom: ${(p) => (p.active ? colors.APP_GRAY_LIGHT : 'none')};
    color: ${(p) => (p.active ? colors.COLOR_PRIMARY : colors.APP_WHITE)};
    @media (max-width: 768px) {
        width: initial;
        margin-bottom: 12px;
        border-bottom: 1px solid rgba(83, 71, 103, 0.4);
    }
`
